import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-126c23a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"50px","padding":"20px 0px 0px 0px"} }, [
  /*#__PURE__*/_createTextVNode("出版日"),
  /*#__PURE__*/_createElementVNode("span", { class: "label required required-date" }, "必須")
], -1))
const _hoisted_5 = { style: {"display":"flex","gap":"0.5rem"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "～", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-description" }, "出版日の範囲がない場合は「～」の左側のみ入力してください。月、日は空欄でも結構です。", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 出版日を入力してください。 ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "コード情報", -1))
const _hoisted_10 = { style: {"display":"flex","gap":"0.5rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_InputDateDms = _resolveComponent("InputDateDms")!
  const _component_TextAlert = _resolveComponent("TextAlert")!
  const _component_AppInput = _resolveComponent("AppInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        _hoisted_3,
        _createVNode(_component_FormInput, {
          modelValue: _ctx.state.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
          name: '題名',
          description: '例：ライブラリー・ニューズレター',
          required: true,
          id: 'title',
          width: '10px',
          requiredCheck: _ctx.props.requiredCheck
        }, null, 8, ["modelValue", "requiredCheck"]),
        _createVNode(_component_FormInput, {
          modelValue: _ctx.state.edition,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.edition) = $event)),
          name: '版表示',
          description: '例：改訂版、第2版',
          required: false,
          id: 'edition',
          width: '50px'
        }, null, 8, ["modelValue"]),
        _createVNode(_component_FormInput, {
          modelValue: _ctx.state.volume,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.volume) = $event)),
          name: '巻号',
          description: '例：第10巻1号、2013年夏号、3号～15号',
          required: false,
          id: 'volume',
          width: '50px'
        }, null, 8, ["modelValue"]),
        _createVNode(_component_FormInput, {
          modelValue: _ctx.state.author,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.author) = $event)),
          name: '作成者',
          description: '当該オンライン資料の著者・編者等を入力してください。',
          required: false,
          id: 'author',
          width: '50px',
          requiredCheck: _ctx.props.requiredCheck
        }, null, 8, ["modelValue", "requiredCheck"]),
        _createVNode(_component_FormInput, {
          modelValue: _ctx.state.publisher,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.publisher) = $event)),
          name: '出版者',
          description: '当該オンライン資料の出版者・公開者を入力してください。',
          required: true,
          id: 'publisher',
          width: '10px',
          requiredCheck: _ctx.props.requiredCheck
        }, null, 8, ["modelValue", "requiredCheck"]),
        _createElementVNode("tr", null, [
          _hoisted_4,
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_AppSelect, {
                modelValue: _ctx.state.publishYear,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.publishYear) = $event)),
                options: _ctx.publishYearList,
                class: "selelct-publishYear"
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_component_InputDateDms, {
                modelValue: _ctx.state.publishFrom,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.publishFrom) = $event)),
                componentId: 'fromDate',
                onBlurCheck: _ctx.blur
              }, null, 8, ["modelValue", "onBlurCheck"]),
              _hoisted_6,
              _createVNode(_component_InputDateDms, {
                modelValue: _ctx.state.publishTo,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.publishTo) = $event)),
                componentId: 'toDate'
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_7,
            (!_ctx.state.publishFrom.includes('年') && (_ctx.blurFlag || _ctx.props.requiredCheck))
              ? (_openBlock(), _createBlock(_component_TextAlert, {
                  key: 0,
                  class: _normalizeClass('errMsg-date')
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_9,
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_AppSelect, {
                modelValue: _ctx.state.codeType,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.codeType) = $event)),
                options: _ctx.codeTypeList,
                class: "selelct-code"
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_component_AppInput, {
                modelValue: _ctx.state.code,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.code) = $event)),
                label: "コード情報",
                inputId: `input-code`
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ])
    ])
  ]))
}